import React from 'react';
import { useTable } from 'react-table';
import ReportData2 from './ReportData2';
function Table({ columns, data,d1,d2 }) {
  // Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable({
    columns,
    data,
  })
  // Render the UI for your table
  return (
    <div className='Report_Table text-center' {...getTableProps()}>
      <div>
        {headerGroups.map(headerGroup => (
          <div className='row' style={{ backgroundColor: "#D9EECF" }}{...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map(column => (
              <div className='colR' {...column.getHeaderProps({
                style: {width: column.width },
              })}>{column.render('Header')}</div>
            ))}
          </div>
        ))}
      </div>
      <div {...getTableBodyProps()}>
        {rows.map((row, i) => {
          prepareRow(row)
          return (
            <div className='row ' {...row.getRowProps()}>
              {row.cells.map(cell => {
                return <div  className='colR'{...cell.getCellProps({
                  style: {width: cell.column.width ,textAlign:cell.column.textAlign},
                })}>{cell.render('Cell')}</div>
              })}
            </div>
          )
        })}
        <div className='colR p-1' style={{ backgroundColor: "#D9EECF" }}><span >کل ایام کار</span><span  style={{padding:"0px 10px", margin:"0px 5px", border:"1px solid black", backgroundColor:"white"}}>{d1}</span><span >حاضری کے ایام</span><span style={{padding:"0px 10px", margin:"0px 5px", border:"1px solid black", backgroundColor:"white"}}>{d2}</span></div>
      </div>
    </div>
  )
}

function ReportTable2(props) {
  const columns = React.useMemo(
    () => [
  
      {
        Header: ' نصابی و ہم نصابی سرگرمیوں میں کارکردگی',
        columns: [
          {
            Header: 'نوعیت',
            accessor: 'Nature',
        width: "40%",
        textAlign:"right",
          },
          {
            Header: 'اچھی',
            accessor: 'G',
            width: "15%",
            textAlign:"center",
          },
          {
            Header: 'بہت اچھی',
            accessor: 'VG',
            width: "20%",
            textAlign:"center",
          },
          {
            Header: 'بہتری کی گنجائش',
            accessor: 'ReMarks',
            width: "25%",
            textAlign:"center",
          },
        ],
      },
    ],
    []
  )

  const data = React.useMemo(() => ReportData2(props), [])

  return (

    <Table columns={columns} data={data} d1={props.data[26]} d2={props.data[27]} />

  )
}

export default ReportTable2
